module.exports = __webpack_public_path__ + "media/images/emblems/Veysonnaz.blason-6682247a4630bdd8c8d44135cb85bdab.png";